import type { Character } from '@/lib/stores/lobbyStore';

/**
 * Merge a fresh /api/characters response into the existing in-store characters,
 * preserving any WS-hydrated `session` / `avatar` data per id. Without this,
 * the permanent-only API response would clobber the richer session snapshot
 * delivered by `lobby:session-state` and leave the char-sheet reading an empty
 * `equipped_slots`.
 *
 * Lives in a standalone module (not LobbyLayout.tsx) so the unit test can
 * import it without dragging React + the full lobby component graph into the
 * test harness.
 */
export function mergeApiCharactersWithStore(
  existing: Character[],
  apiChars: Array<{ id: string; name: string; avatar?: unknown } & Record<string, unknown>>
): Character[] {
  const existingById = new Map(existing.map((c) => [c.id, c]));
  return apiChars.map((char) => {
    const prior = existingById.get(char.id);
    return {
      ...prior,
      id: char.id,
      name: char.name,
      permanent: char as unknown as Character['permanent'],
      session: prior?.session,
      avatar: prior?.avatar ?? (char.avatar as string | undefined),
    };
  });
}
